(function(){
  const ready=(fn)=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn();
  ready(()=>{
    const header=document.querySelector('[data-sbx-header]');
    const setHeader=()=>header?.classList.toggle('is-scrolled',window.scrollY>16);
    setHeader(); window.addEventListener('scroll',setHeader,{passive:true});
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      const layers=document.querySelectorAll('[data-sbx-parallax]');
      const update=()=>{layers.forEach(layer=>{const r=layer.parentElement.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight){layer.style.transform=`translate3d(0,${Math.max(-28,Math.min(28,-r.top*.025))}px,0) scale(1.035)`;}})};
      update(); window.addEventListener('scroll',update,{passive:true});
    }
  });
})();
